import React, {Fragment} from 'react';
import "react-quill/dist/quill.snow.css";
import {useSearchParams} from "react-router-dom";
import HumanDetails from "./HumanDetails/HumanDetails";
import AnimalDetails from "./AnimalDetails/AnimalDetails";
import HerbalDetails from "./HerbalDetails/HerbalDetails";
import CropDetails from "./CropDetails/CropDetails";
import AgroDetails from "./AgroDetails/AgroDetails";
import GardenDetails from "./GardenDetails/GardenDetails";
import PetDetails from "./PetDetails/PetDetails";

const ProductDetails = () => {
    const [searchParams] = useSearchParams();
    const division = Number(searchParams.get("division"));

    return (
        <Fragment>
            {
                Number(division)===8 ? <HumanDetails/> :
                    Number(division)===9 ? <AnimalDetails/>:
                        Number(division)===10 ? <HerbalDetails/>:
                            Number(division)===11 ? <CropDetails/>:
                                Number(division)===12 ? <AgroDetails/>:
                                    Number(division)===14 ? <GardenDetails/>:
                                        <PetDetails/>
            }
        </Fragment>
    );
};

export default ProductDetails;